<template>
    <v-dialog v-model="dialog" max-width="400" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ $t('common.pain_scale') }}
            </v-card-title>
            <v-card-text class="mt-6">
                <v-row>
                    <v-col cols="12" class="pain-label">
                        {{ $t('common.much_pain') }}
                    </v-col>
                    <v-col cols="12">
                        <div class="mr-2">
                            <kimsa-slider-vertical color="secondary" :labels-interval="0" :value="scale" :step="1" :min="0"
                            :max="10" with-background @change="scale = $event" ref="scale" />
                        </div>
                    </v-col>
                    <v-col cols="12" class="pain-label">
                        {{ $t('common.no_pain') }}
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text" @click="save"
                    :loading="loading">
                    {{ $t('common.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import KimsaSliderVertical from './inputs/KimsaSliderVertical.vue';

export default {
    components: { KimsaSliderVertical },
    name: "PainScaleDialog",
    props: {
        exercise: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            scale: 5,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
        },
        save() {
            const vm = this;
            vm.$emit('success', vm.scale)
            vm.hide()
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.card-container {
    border-radius: 0px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}

.pain-label {
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
}
</style>